export interface DesignerRevision {
    designerId: string;
    revisionDesignsCount: number;
    totalDesignsCount: number;
    treatmentTypeOriginalId: number;
    dataKey?: string;
}

export type DesignerRevisions = DesignerRevision[];

export interface GroupedDesignerRevision {
    designerId: string;
    items: DesignerRevisions;
}
